import type { ReactNode } from "react";

import { styles } from "@repo/helpers";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../basic/card";

interface Props {
	title?: string;
	description?: string;

	version?: string;

	logoImage?: string;
	backgroundImage?: string;

	children: ReactNode;
}

export function LoginBackground(props: Props) {
	const { title, description, version, logoImage, backgroundImage, children } = props;

	return (
		<div
			className={styles(
				"tw-flex tw-h-screen tw-w-full tw-flex-col tw-items-center tw-justify-center",
				backgroundImage
					? `tw-bg-[url(${backgroundImage})]`
					: "tw-bg-[url(/images/Backgrounds/bkdg-default.jpg)]",
			)}
		>
			<div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center">
				<img className="tw-h-24" alt="TLP Cloud Logo" src={logoImage ?? "/Content/Logos/TLPLogo2.png"} />
				<Card className="tw-mx-auto tw-w-96 tw-max-w-sm">
					<CardHeader>
						<CardTitle className="tw-text-2xl">{title}</CardTitle>
						<CardDescription>{description}</CardDescription>
					</CardHeader>
					<CardContent>
						{children}
						{version !== undefined && (
							<span className="tw-text-sm tw-text-muted-foreground">Version: {version}</span>
						)}
					</CardContent>
				</Card>
			</div>
			<div className="tw-flex tw-h-48 tw-w-full tw-flex-col tw-items-center tw-justify-center">
				<h2 className="tw-text-sm tw-font-bold">Powered by</h2>
				<img className="tw-h-24" alt="TLP Cloud Logo" src="/Content/Logos/TLPLogo2.png" />
			</div>
		</div>
	);
}
